"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentEvents = void 0;
var ShipmentEvents;
(function (ShipmentEvents) {
    ShipmentEvents["BucketChanged"] = "shipment.fct.bucket-changed.v1";
    ShipmentEvents["CarrierAssignment"] = "shipment.fct.carrier-assignment.v2";
    ShipmentEvents["DeliveryReceiptUploaded"] = "documents.fct.delivery-receipt-uploaded.v1";
    ShipmentEvents["Freight"] = "shipment.fct.freight.v1";
    ShipmentEvents["ShipmentChanged"] = "shipment.cdc.shipment-changed.v1";
    ShipmentEvents["ShipmentDocumentAssigned"] = "shipment.fct.document-assigned.v1";
    ShipmentEvents["StatusUpdated"] = "shipment.fct.status.v1";
    ShipmentEvents["StatusUpdatedV2"] = "shipment.fct.status.v2";
    ShipmentEvents["Waypoint"] = "shipment.fct.waypoint.v1";
    ShipmentEvents["WaypointNote"] = "shipment.fct.waypoint-note.v1";
})(ShipmentEvents = exports.ShipmentEvents || (exports.ShipmentEvents = {}));
//# sourceMappingURL=ShipmentEvents.js.map